import React from 'react';
import classes from './Tag.module.css';

const tag = (props) => {
  return (
    <span onClick={props.clicked} className={[classes.Tag, classes[props.tagType]].join(' ')} key={`tag-${props.tag}`}>
      {props.tag}
    </span>
  );
};

export default tag;
